import { Route } from '@angular/router';

export const kanziWmsUsersRoutes: Route[] = [
  { path: '', redirectTo: '/users/profile', pathMatch: 'full' },
  {
    path: 'profile',
    loadComponent: () =>
      import('./pages/kanzi-user-profile/kanzi-user-profile.component').then(
        (m) => m.KanziUserProfileComponent
      ),
    data: {
      breadcrumb: 'Profile',
    },
  },
];

export const kanziWmsUsersAdministrationRoutes: Route[] = [
  { path: '', redirectTo: '/administration/users/list', pathMatch: 'full' },
  {
    path: 'list',
    loadComponent: () =>
      import('./pages/kanzi-user-list/kanzi-user-list.component').then(
        (m) => m.KanziUserWMSListComponent
      ),
    data: {
      breadcrumb: 'Listado',
    },
  },
  {
    path: 'user-creation',
    loadComponent: () =>
      import('./pages/user-creation/user-creation.component').then(
        (m) => m.UserCreationComponent
      ),
    data: {
      breadcrumb: 'Creación Usuario',
    },
  },
];
